module.exports = __webpack_public_path__ + "static/80s-0079a6c7e07a304944153334f3051fbe.jpg";